import { render, staticRenderFns } from "./exportacaoFamiliasSemConta.vue?vue&type=template&id=31569b7e&scoped=true&"
import script from "./exportacaoFamiliasSemConta.vue?vue&type=script&lang=js&"
export * from "./exportacaoFamiliasSemConta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31569b7e",
  null
  
)

export default component.exports